import Joi from 'joi';

import { updateTenantBillingSchema } from '../../../billing/validators/schemas/update-tenant-billing.schema';
import { updateTenantContactSchema } from '../../../contacts/validators/schemas/update-tenant-contact.schema';

/**
 * Schema for existing tenant record validation.
 */
export const updateTenantSchema = () =>
  Joi.object({
    email: Joi.string().email(),
    // Contact
    contact: updateTenantContactSchema(),
    billing: updateTenantBillingSchema().optional(),
  })
    // Ignore extra fields
    .unknown();
